import { RgDataSetID } from './rg-data-set-id.js';

const AggConfigSets = {
    [RgDataSetID.uk_01]: {
        maxApartments: 8,
        maxTravelDist: 7.5,
        maxTravelDistSprinklered: 15,
        maxTravelDistBidirectional: 30,
        moduleDepth: 7.475,
        corridorWidth: 2,
        maxApartmentDepth: 9.275,
        f2fHeight: 3,
        gap: 0.025,
        face2FaceSeparation: 18,
        face2SideSeparation: 12,
        sprinkleredFflThreshold: 11,
        gridCellWidth: 0,
        // core properties
        coreWithStairs: {
            size: [3, 7.475],
            doorPositions: [[0.415, 0]],
            rules: [{
                    count: 2,
                    ffl: [30, Infinity]
                }]
        },
        coreWithLifts: {
            size: [6.9, 7.475],
            doorPositions: [[-1.965, 0]],
            rules: [{
                    count: 1,
                    floors: [4, Infinity]
                }]
        },
        coreWithFfLifts: {
            size: [6.9, 7.475],
            doorPositions: [[-1.965, 0]],
            rules: [{
                    count: 1,
                    ffl: [18, Infinity],
                    gia: [0, 900]
                },
                {
                    count: 2,
                    ffl: [18, Infinity],
                    gia: [900, Infinity]
                }]
        },
        cornerCore: {
            size: [7.475, 7.475],
            doorPositions: [
                [-0.415, 0],
                [0, -1.965] // Closest door corner to closest core corner (right side)
            ]
        }
    },
    [RgDataSetID.uk_02]: {
        maxApartments: 8,
        maxTravelDist: 7.5,
        maxTravelDistSprinklered: 15,
        maxTravelDistBidirectional: 30,
        moduleDepth: 7.175,
        corridorWidth: 2,
        maxApartmentDepth: 9.1875,
        f2fHeight: 3,
        gap: 0.05,
        face2FaceSeparation: 18,
        face2SideSeparation: 12,
        sprinkleredFflThreshold: 11,
        gridCellWidth: 3.775 + 0.05,
        // core properties
        coreWithStairs: {
            size: [3.775, 7.3528],
            doorPositions: [[0.415, 0]],
            rules: [{
                    count: 2,
                    ffl: [30, Infinity]
                }]
        },
        coreWithLifts: {
            size: [3.775 * 2 + 0.05, 5.725],
            doorPositions: [[-1.965, 0]],
            rules: [{
                    count: 1,
                    floors: [4, Infinity]
                }]
        },
        coreWithFfLifts: {
            size: [3.775 * 2 + 0.05, 5.725],
            doorPositions: [[-1.965, 0]],
            rules: [{
                    count: 1,
                    ffl: [18, Infinity],
                    gia: [0, 900]
                },
                {
                    count: 2,
                    ffl: [18, Infinity],
                    gia: [900, Infinity]
                }]
        },
        cornerCore: {
            size: [8.71, 5.65],
            doorPositions: [
                [-0.415, 0],
                [0, -1.965] // Closest door corner to closest core corner (bottom up)
            ]
        }
    }
};

export { AggConfigSets };
//# sourceMappingURL=agg-config-set.js.map
